import * as MSAL from "@azure/msal-browser";

export const PolicyId = "b2c_1a_acma_signup_signin";

export const getScopes = (domain: string) => {
  let scopes = ["openid", `https://${domain}.onmicrosoft.com/AcmaApis/Call`];
  return scopes;
};

var msalClient: MSAL.PublicClientApplication | null = null;

export const msalGetOrCreate = async (b2cEndpoint: string, domain: string, clientId: string, postLogoutRedirectUri: string) => {
  msalClient = new MSAL.PublicClientApplication({
    auth: {
      clientId: clientId,
      authority: `https://${b2cEndpoint}/${domain}.onmicrosoft.com/${PolicyId}`,
      postLogoutRedirectUri: postLogoutRedirectUri,
      knownAuthorities: [`${b2cEndpoint}`],
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
  });

  await msalClient.initialize();

  return msalClient;
};

var msalRedirect: MSAL.AuthenticationResult | null = null;

export const msalHandlerRedirect = async (msalClient: MSAL.PublicClientApplication) => {
  if (!msalRedirect) {
    msalRedirect = await msalClient.handleRedirectPromise();
  }
  return msalRedirect;
}


export const msalSignIn = async (domain: string, msalClient: MSAL.PublicClientApplication) => {
  let scopes = getScopes(domain);
  await msalClient.loginRedirect({
    scopes,
    state: document.location.hash
  });
};

export const msalGetToken = async (domain: string, msalClient: MSAL.PublicClientApplication) => {
  let allAccounts = msalClient.getAllAccounts();
  let scopes = getScopes(domain);
  if (allAccounts.length > 0) {
    try {
      let token = await msalClient.acquireTokenSilent({
        account: allAccounts[0],
        scopes,
      });
      if (!token.accessToken) {
        throw new MSAL.InteractionRequiredAuthError();
      }
      return token.accessToken;
    } catch (error) {
      if (error instanceof MSAL.InteractionRequiredAuthError) {
        msalSignIn(domain, msalClient);
      } else {
        console.log(error);
      }
    }
  }
  return undefined;
};

const msalCallback: { (): any }[] = []
export const msalSubscribe = (callback: { (): any }) => msalCallback.push(callback);
export const msalTrigger = () => {
  for (let c of msalCallback) {
    c();
  }
}